// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"D9-z"};